import { IDynamicLinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { azuerFileBasicAuthOptions, calAzureFileStorageMetadata } from './azure-file-storage-metadata';

export const azureFileStorageMetadataSsis: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    return await calAzureFileStorageMetadata(injector, azuerFileBasicAuthOptions, true, 'SSIS');
};
